<template>
  <div>
    <new-hcc-cep-form
      rails_env="rails_env"
      :cep="cep"
      :clients="clients"
      :contacts="contacts"
      :bill_infos="bill_infos"
      :cep_interlocs="cep_interlocs"
      :project_codes="project_codes"
    ></new-hcc-cep-form>
  </div>
</template>

<script>
  export default {
    props: {
      rails_env: String,
      cep: Object,
      clients: Array,
      contacts: Array,
      bill_infos: Array,
      cep_interlocs: Array,
      project_codes: Array,
    },

    data(){
      return {

      }
    },

    methods: {

    }
  }
</script>